module.exports = __webpack_public_path__ + "img/icon-check.df5bebe5.svg";